export const execute = async (executor: Function, errorHandler: Function) => {
    try {
        return await executor();
    } catch (e) {
        return errorHandler(e);
    }
};
